export default {
    sexOptions: [{
            name: '男',
            value: 'M'
        },
        {
            name: '女',
            value: 'F'
        }
    ],
    idOptions: [{
            name: '身份证',
            value: '1'
        },
        {
            name: '护照',
            value: '2'
        },
        {
            name: '军官证',
            value: '3'
        },
        {
            name: '驾驶证',
            value: '4'
        },
        {
            name: '出生证',
            value: '5'
        },
        {
            name: '居民户口簿',
            value: '6'
        },
        {
            name: '其他',
            value: '99'
        }
    ],
    gdIdTypeOptions:[//团单证件类型
        {
            name: '居民身份证',
            value: '11'
        },{
            name: '中国护照',
            value: '17'
        },{
            name: '外国护照',
            value: '24'
        }, {
            name: '台胞证',
            value: '23'
        },{
            name: '港澳居民居住证',
            value: '29'
        },{
            name: '台湾居民居住证',
            value: '30'
        },
    ],
    //光大监护人
    guardianIdOptions:[
        {
            name: '居民身份证',
            value: '11'
        },
        {
            name: '外国护照',
            value: '24'
        },{
            name: '台湾居民往来大陆通行证',
            value: '23'
        },{
            name: '港澳居民往来内地通行证',
            value: '26'
        }
    ],
    //光大被保人
    gdIdTypeOptions1:[
        {
            name: '居民身份证',
            value: '11'
        },{
            name: '居民户口簿',
            value: '12'
        },{
            name: '出生证',
            value: '20'
        },{
            name: '外国护照',
            value: '24'
        },{
            name: '台湾居民往来大陆通行证',
            value: '23'
        },{
            name: '港澳居民往来内地通行证',
            value: '26'
        }
    ],

}